import { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./Global/ScrollToTop";
import { WaitlistOverlayHost } from "./Global/WaitlistToast";

const Home = lazy(() => import("./HomeComponent/Home"));
const AboutUs = lazy(() => import("./AboutComponent/AboutUs"));
const ContactUs = lazy(() => import("./ContactUs/ContactUs"));
const PrivacyPolicy = lazy(() => import("./PrivacyPolicy/Privacypolicy"));
const TermsAndConditions = lazy(() => import("./TermsAndConditions/TermsAndConditions"));
const CancellationPolicy = lazy(() => import("./CancellationPolicy/CancellationPolicy"));
const Faqs = lazy(() => import("./Faqs/Faqs"));
const Traveler = lazy(() => import("./Traveler/Traveler"));
const Sender = lazy(() => import("./Sender/Sender"));
const TwoWaySearch = lazy(() => import("./TwoWaySearch/TwoWaySearch"));
const SafeSecure = lazy(() => import("./SafeSecure/SafeSecure"));
const SmsOptIn = lazy(() => import("./SmsOptIn/SmsOptIn"));

const RouteFallback = () => (
  <div className="min-h-screen bg-white flex items-center justify-center text-[#7A0056] font-medium">
    Loading...
  </div>
);

function App() {
  return (
    <Router>
      <WaitlistOverlayHost />
      <Toaster
        position="top-center"
        containerStyle={{ top: 96 }}
        toastOptions={{
          duration: 4000,
          style: {
            fontFamily: "'Poppins', sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            color: "#111827",
            background: "#ffffff",
            borderRadius: "12px",
            padding: "13px 18px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.16)",
            maxWidth: "400px",
            minWidth: "260px",
          },
        }}
      />
      <Suspense fallback={<RouteFallback />}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/term" element={<TermsAndConditions />} />
          <Route path="/cancellation" element={<CancellationPolicy />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/traveler" element={<Traveler />} />
          <Route path="/sender" element={<Sender />} />
          <Route path="/two-way-search" element={<TwoWaySearch />} />
          <Route path="/safe-secure" element={<SafeSecure />} />
          <Route path="/sms-opt-in" element={<SmsOptIn />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
